module.exports = __webpack_public_path__ + "img/FrameDimensions2.e2452cca.png";